import slice from "./storeOpportunitiesSlice";

export default slice.reducer;
